import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  pageSx,
  containerSx,
  mainTitleSx,
  sectionTitleSx,
  sectionTextSx,
  listSx,
} from "./Page.sx";
import { Footer } from "../../components/Layout";

export default function PrivacyPolicyPage() {
  return (
    <Box sx={pageSx}>
      <Box sx={containerSx}>
        <Stack gap={3}>
          {/* Main Title */}
          <Typography component="h1" sx={mainTitleSx}>
            Privacy Policy for Cledar
          </Typography>

          {/* Intro */}
          <Typography sx={sectionTextSx}>
            Cledar SP Z.o.o. ul, and Cledar USA, Inc., ("Cledar", "We", "Us",
            "Our") respect your privacy. We strive to use information to provide
            the best possible service while respecting the confidentiality of
            information we are given. This Privacy Policy outlines the types of
            personal information we may receive or collect when you use our
            services, and methods we use to safeguard your personal information.
          </Typography>

          {/* Section 1 */}
          <Typography component="h2" sx={sectionTitleSx}>
            1. Collection of personal information
          </Typography>
          <Typography sx={sectionTextSx}>
            We collect personal information to establish your to understand your
            specific needs to serve you better. Personal information is
            information about you that is personally identifiable, such as your
            name, address, email address, or phone number. We may use cookies,
            tracking pixels, and other technologies to enhance your online
            experience and to learn about how you use our website and services.
            A "cookie" is a small file containing a string of characters that
            uniquely identifies your browser. While most browsers accept cookies
            by default, you can manually set your browser to refuse all cookies,
            accept cookies from specific websites, or highlight when a cookie is
            sent to your browser. Our servers may also automatically record
            information when you visit our website, including the URL that
            directed you to our website, your IP address, browser type and the
            date and time of your visit.
          </Typography>

          {/* Section 2 */}
          <Typography component="h2" sx={sectionTitleSx}>
            2. How we use your information
          </Typography>
          <Typography sx={sectionTextSx}>
            The information we collect is used to comprehensively understand
            your needs and interests, and permits Us to deliver a more
            consistent and personalized experience. For example, We may use your
            information to:
          </Typography>
          <Box component="ol" sx={listSx}>
            <li>assist you in completing a transaction or order;</li>
            <li>communicate with you about products and services;</li>
            <li>provide service and support;</li>
            <li>update you on new services and benefits;</li>
            <li>provide personalized promotional offers;</li>
            <li>select content to be communicated to you;</li>
            <li>
              contact you for market research regarding Our products or
              services;
            </li>
          </Box>
          <Typography sx={sectionTextSx}>
            Your information may be aggregated with other clients information on
            a purely non identifiable basis to understand how our products are
            used to help make them better.
          </Typography>

          {/* Section 3 */}
          <Typography component="h2" sx={sectionTitleSx}>
            3. Policy on sharing your information
          </Typography>
          <Typography sx={sectionTextSx}>
            We will not sell, rent or lease your personal information to others.
            We may share personal information with companies working on our
            behalf and Cledar owned business entities for the purposes detailed
            above. In any such cases, however, we require that the companies or
            entities adhere to privacy standards and policies at least as
            restrictive as those We have in place.
          </Typography>
          <Typography sx={sectionTextSx}>
            We may have a good faith belief that access, use, preservation or
            disclosure of such information is reasonably necessary to:
          </Typography>
          <Box component="ol" sx={listSx}>
            <li>
              satisfy any applicable law, regulation, legal process or
              legitimate governmental request;
            </li>
            <li>
              detect, prevent, or otherwise address suspected fraud, security or
              technical issues;
            </li>
            <li>
              enforce any applicable Terms of Service, including investigation
              of potential violations thereof;
            </li>
            <li>
              protect against imminent harm to the rights, property or safety of
              Us, Our users or the general public as required or permitted by
              law.
            </li>
          </Box>

          {/* Section 4 */}
          <Typography component="h2" sx={sectionTitleSx}>
            4. Sites covered by this Privacy Policy
          </Typography>
          <Typography sx={sectionTextSx}>
            Our websites (www.cledar.com) may link to third party websites for
            your convenience and to provide easy access to additional useful
            information. Should you select such a link you will leave Our
            website. We do not control those sites nor their privacy practices,
            which may differ from Our practices and policies. Any personal data
            you choose to provide to or that is collected by such third parties
            is not covered by Our Privacy Policy. We recommend that you read
            over such website s privacy policy before providing any personal
            information. A link to another website from Our does not constitute
            an endorsement or representation about the value, quality or
            usefulness of anything found on that third party website.
          </Typography>

          {/* Section 5 */}
          <Typography component="h2" sx={sectionTitleSx}>
            5. Access to and accuracy of your information
          </Typography>
          <Typography sx={sectionTextSx}>
            We strive to keep your personal information accurate and up to date.
            Towards this goal we utilize various technology, management
            processes and policies. As part of our overall data accuracy
            initiative We provide you with reasonable access to your personal
            information so you may review and correct your information if
            needed.
          </Typography>

          {/* Section 6 */}
          <Typography component="h2" sx={sectionTitleSx}>
            6. Keeping your information secure
          </Typography>
          <Typography sx={sectionTextSx}>
            We value your trust and takes it seriously. To prevent unauthorized
            access and disclosure, to maintain data accuracy, and to ensure the
            appropriate use of your information, We utilize industry standard
            physical, technical and administrative procedures to safeguard any
            personal information we collect.
          </Typography>

          {/* Section 7 */}
          <Typography component="h2" sx={sectionTitleSx}>
            7. Changes to this policy
          </Typography>
          <Typography sx={sectionTextSx}>
            This Privacy Policy may be modified by Us in our sole discretion,
            and such modifications shall be binding once published on our
            website.
          </Typography>

          {/* Section 8 */}
          <Typography component="h2" sx={sectionTitleSx}>
            8. Contact
          </Typography>
          <Typography sx={sectionTextSx}>
            Contacting us Please email us with any questions or concerns at{" "}
            <Box
              component="a"
              href="mailto:privacy@cledar.com"
              sx={{
                fontWeight: 600,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              privacy@cledar.com
            </Box>
            .
          </Typography>
        </Stack>
      </Box>
      <Footer />
    </Box>
  );
}
